import React from 'react';
import { useParams } from 'react-router-dom';
import { Grid } from '@mui/material';
import CustomCard2 from '../../components/cards/CustomCard2';
import BrandDetailsSidebar from '../../components/sidebars/BrandDetailsSidebar';
import ProductWidget from '../../components/widgets/ProductWidget';
import NoDataFeedback from '../../components/feedbacks/NoDataFeedback';
import PageLayout from '../layouts/PageLayout';
import { useDispatch, useSelector } from 'react-redux';
import { map, size } from 'lodash';

import {
  useGetSingleBrandQuery,
  useGetBrandProductsQuery,
} from '../../api/brands/brandAPI';
import { setBrand, setBrandProducts } from '../../features/brandSlice';

// !############### MAIN FUNC ####################
const BrandDetails = () => {
  const dispatch = useDispatch();
  const { brand_id } = useParams();
  const { data: brandProducts, isSuccess: brandProdSuccess } =
    useGetBrandProductsQuery(brand_id);
  const { data: brandData, isSuccess } = useGetSingleBrandQuery(brand_id);

  if (isSuccess) {
    dispatch(setBrand({ brand: brandData.data }));
  }

  if (brandProdSuccess) {
    dispatch(setBrandProducts({ brandProducts: brandProducts.data }));
  }

  const brand = useSelector((state) => state.brands.brand);
  const products = useSelector((state) => state.brands.brandProducts);

  return (
    <>
      <PageLayout
        sidebar={<BrandDetailsSidebar brand={brand} />}
        head="Brands details"
      >
        <CustomCard2 title={`Brand products`} height={640}>
          <Grid container spacing={3} padding={2}>
            {size(products) > 0 ? (
              map(products, ({ product_details }) => (
                <Grid
                  item
                  sm={2}
                  key={product_details.product_id}
                  sx={{ position: 'relative' }}
                >
                  <ProductWidget
                    product_banner={product_details.product_banner}
                    product_price={product_details.product_price}
                    product_name={product_details.product_name}
                    discounted_price={product_details.discounted_price}
                    isOnSale={product_details.isOnSale}
                    product_id={product_details.product_id}
                  />
                </Grid>
              ))
            ) : (
              <NoDataFeedback message="No product found" />
            )}
          </Grid>
        </CustomCard2>
      </PageLayout>
    </>
  );
};

export default BrandDetails;
